export default "__VITE_ASSET__BNgrArz8__"